var map = {
	"./testContract/marginPosition/10143": 60276,
	"./testContract/marginPosition/10143.js": 60276,
	"./testContract/marginPosition/11155111": 53309,
	"./testContract/marginPosition/11155111.js": 53309,
	"./testContract/marginPosition/130": 13989,
	"./testContract/marginPosition/130.js": 13989,
	"./testContract/marginPosition/1301": 22906,
	"./testContract/marginPosition/1301.js": 22906,
	"./testContract/marginPosition/1439": 33892,
	"./testContract/marginPosition/1439.js": 33892,
	"./testContract/marginPosition/1776": 43760,
	"./testContract/marginPosition/1776.js": 43760,
	"./testContract/marginPosition/50312": 67428,
	"./testContract/marginPosition/50312.js": 67428,
	"./testContract/marginPosition/56": 8722,
	"./testContract/marginPosition/56.js": 8722,
	"./testContract/marginPosition/57054": 72272,
	"./testContract/marginPosition/57054.js": 72272,
	"./testContract/marginPosition/97": 80749,
	"./testContract/marginPosition/97.js": 80749,
	"./testContract/marginPosition/998": 94903,
	"./testContract/marginPosition/998.js": 94903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87945;